<template>
    <div>
      <div class="flex flex-wrap justify-between items-center mb-4">
        <h5>Phone</h5>
      </div>
      <div class="table-responsive">
        <table class="light_blue_table w-full">
          <tbody>
            <tr>
              <td>
                <div class="flex items-center">
                  <span class="material-icons-outlined small_icon">phone</span>
                  Phone
                </div>
              </td>
              <td>{{ clientDetails.basic_details.mobile }}</td>
              <td>
                <vs-dropdown>
                  <vs-button
                    class="btn-drop"
                    type="flat"
                    icon="more_vert"
                  ></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                       :disabled="!checkEditPermission"
                      @click="handleeditphone()"
                    >
                      Edit
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <vs-popup
        classContent="popup-example"
        title="Edit Phone"
        :active.sync="phoneeditpopup"
      >
        <form data-vv-scope="edit">
          <vs-row>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                v-validate="'required'"
                name="phone"
                v-model="editphone"
                class="custom_Input"
                label="Phone number"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                style="width: 100%"
              />
              <span v-show="errors.has('edit.phone')" class="text-danger">{{
                errors.first("edit.phone")
              }}</span>
            </vs-col>
          </vs-row>
        </form>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click.prevent="handleUpdatePhone"
            >Save</vs-button
          >
          <vs-button type="border" color="danger" @click="phoneeditpopup = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
    </div>
  </template>
<script>
import { StudentMixins } from '@/views/pages/v1/StudentProfile/mixins/studentMixin.js'

export default {
  name: 'phone',
  mixins:[StudentMixins],
  props: {
    clientDetails: {
      required: true,
      default: () => []
    },
    checkEditPermission:{
      default: false
    }
  },
  data () {
    return {
      phoneeditpopup: false,
      editphone: null,
      phoneAvailability: []
    }
  },

  methods: {
    handleeditphone () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editphone = this.clientDetails.basic_details.mobile
      this.phoneeditpopup = true
    },
    handleUpdatePhone () {
      if (isNaN(this.editphone)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be digit only',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      } else if (this.editphone.length !== 10 && this.clientDetails.basic_details.address.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be 10 digits',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      } else if (![9, 8, 7, 6].includes(Number(String(this.editphone).charAt(0))) && this.clientDetails.basic_details.address.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number is incorrect',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      }
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.clientDetails.basic_details.mobile = this.editphone
          this.handlePhonesave()
        }
      })
    },
    async handlePhonesave () {
      try {
        this.UpdateDetails(this.clientDetails.basic_details.client_users_id)
        this.phoneeditpopup = false
        this.$emit('userUpdated', true)
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
